// Banka kart-programı logoları (legacy temadan) → banka anahtarı eşlemesi.
// CardFinans→QNB, Axess→Akbank, Maximum→İş Bankası, World→Yapı Kredi, Bonus→Garanti.
import qnb from '../assets/banks/qnb.png';
import akbank from '../assets/banks/akbank.png';
import isbankasi from '../assets/banks/isbankasi.png';
import yapikredi from '../assets/banks/yapikredi.png';
import garanti from '../assets/banks/garanti.png';

export const BANK_LOGOS: Record<string, string> = { qnb, akbank, isbankasi, yapikredi, garanti };

/** Banka anahtarına karşılık gelen logo URL'i (yoksa undefined). */
export function bankLogo(key: string | null | undefined): string | undefined {
  return key ? BANK_LOGOS[key] : undefined;
}
